var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatappFloat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 79L6.794 58.6194C3.3466 52.821 1.36207 46.0543 1.36207 38.819C1.36207 17.38 18.7421 0 40.181 0C61.62 0 79 17.38 79 38.819C79 60.2579 61.62 77.6379 40.181 77.6379C33.6581 77.6379 27.5152 76.0212 22.12 73.1799L0 79Z",
    fill: "#2CB742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9482 51.7382C63.1557 48.3507 56.5456 44.477 56.5456 44.477C55.0501 43.6244 53.2453 43.529 52.3927 45.0491C52.3927 45.0491 50.2447 47.6248 49.6985 47.9952C47.2032 49.6856 44.8917 49.6202 42.5585 47.287L37.1361 41.8646L31.7137 36.4422C29.3805 34.1089 29.3151 31.7975 31.0055 29.3022C31.3759 28.756 33.9516 26.608 33.9516 26.608C35.4717 25.754 35.3763 23.9506 34.5237 22.4551C34.5237 22.4551 30.65 15.845 27.2625 14.0525C25.8214 13.2897 24.0521 13.5567 22.8998 14.709L20.5053 17.1035C12.909 24.6998 16.6492 33.2754 24.2455 40.8716L31.188 47.8141L38.1304 54.7566C45.7267 62.3528 54.3023 66.0931 61.8985 58.4968L64.293 56.1023C65.4454 54.9472 65.711 53.1779 64.9482 51.7382Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatappFloat);
export default __webpack_public_path__ + "static/media/whatappFloat.8dd3ec26ce902188cdbd63ecbe2cb4e0.svg";
export { ForwardRef as ReactComponent };